import React, { useState, useCallback, useEffect } from 'react'
import {
  Stack,
  Snackbar
} from '@mui/material'
import MuiAlert from '@mui/material/Alert'
import Emitter from '@utils/eventEmitter'

const initOptions = {
  color: 'success', // info, success, error, warning
  text: '',
  autoHideDuration: 3000,
  vertical: 'top',
  horizontal: 'center'
}

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
})

let isOpening = false
let closeTimer = null

const Message = () => {
  const [ open, setOpen ] = useState(false)
  const [ options, setOptions ] = useState(initOptions)

  const showMessage = useCallback((data) => {
    if (isOpening) {
      return
    }
    isOpening = true

    if (closeTimer) {
      clearTimeout(closeTimer)
      closeTimer = null
    }
    setOptions(Object.assign({}, options, data))
    setTimeout(() => {
      setOpen(true)
      closeTimer = setTimeout(() => {
        hideMessage()
      }, data.autoHideDuration || options.autoHideDuration)
    }, 100)
  }, [ options ])

  const hideMessage = (e) => {
    isOpening = false
    setOpen(false)
    setTimeout(() => {
      setOptions(initOptions)
    }, 100)
  }

  useEffect(() => {
    Emitter.on('SHOW_MESSAGE', showMessage)
    Emitter.on('HIDE_MESSAGE', hideMessage)
    return () => {
      Emitter.off('SHOW_MESSAGE')
      Emitter.off('HIDE_MESSAGE')
    }
  }, [ showMessage ])

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar 
        open={open} 
        anchorOrigin={{ 
          vertical: options.vertical, 
          horizontal: options.horizontal
        }}
      >
        <Alert 
          onClose={hideMessage} 
          severity={options.color} 
          sx={{ width: '100%' }}
        >
          {options.text}
        </Alert>
      </Snackbar>
    </Stack>
  )
}

export default Message